import React from 'react'
import "./Donation.css"
import { useNavigate } from 'react-router-dom'
const DonateAdd = () => {
// useNavigate()
const navi =useNavigate()



  return (
    <div className='main__donationadd'>
      <div className='main_Donation_delectionbox' style={{ margin:' 0 0 0 10px'}} onClick={()=>navi('/donateaddqr')} ><h1>Add Qr</h1></div>
      <div  className='main_Donation_delectionbox'  onClick={()=>navi('/donate_account_add')}><h1>Add Details</h1></div>
    
    </div>
  )
}

export default DonateAdd
